const SemiTheme = {
  colors: {
    primaryDark: "#0f1642",
    primaryLight: "#f2f2f2",
    white: "#ffffff",
    gray200: "#E4E4E4",
    gray300: "#C4C4C4",
    gray500: "#474747",
    gray400: "#777777",
    error: "#973131",
    warning: "#DDA24A",
    success: "#4ADD61",
    mouve: "#9e94ff",
    gold: "#ffd700",
    black: "#000",
    ceruleanFrost: "#64A7C4",
  },
};

export default SemiTheme;
